// extracted by mini-css-extract-plugin
export var article__meta = "single-module--article__meta--2B_eP";
export var article__tax = "single-module--article__tax--JP9-I";
export var article = "single-module--article--1iUKO";
export var article__content = "single-module--article__content--7dEpL";
export var hubText = "single-module--hub-text--1keAX";
export var tagBox = "single-module--tag-box--1ZIbn";
export var tagList = "single-module--tag-list--3vuu5";
export var tag = "single-module--tag--3LpZd";